{
  "columns": {
    "item": "カード",
    "consignor": "委託者",
    "sold": "販売",
    "sold_price": "販売価格",
    "commission": "お店の手数料",
    "card_fee": "カード手数料の負担",
    "proceeds": "委託者の受取",
    "paid": "支払済み",
    "outstanding": "未払い",
    "status": "状態"
  },
  "channel": {
    "web": "サイト",
    "pos": "店頭レジ"
  },
  "settlement_status": {
    "not_applicable": "支払いなし",
    "awaiting_payout": "支払い待ち",
    "processing": "支払い中",
    "adjusted": "変更あり・要確認",
    "partially_paid": "一部支払済み",
    "paid": "支払済み"
  },
  "payout_status": {
    "draft": "下書き",
    "processing": "振込待ち",
    "paid": "支払済み",
    "cancelled": "取り消し"
  },
  "method": {
    "bank_transfer_manual": "銀行振込",
    "cash": "店頭で現金",
    "store_credit": "ストアクレジット"
  },
  "method_hint": {
    "bank_transfer_manual": "銀行で振り込み、ここに記録します。",
    "cash": "レジから支払い、受領書に署名をもらいます。",
    "store_credit": "お店で使えるクレジット（最長6か月）。"
  },
  "codes": {
    "service_fee": "お店の手数料",
    "payment_fee": "カード手数料の負担",
    "shipping": "送料",
    "grading_fee": "鑑定料",
    "other": "その他",
    "refund_reversal": "返金"
  },
  "skip": {
    "below_minimum": "最低支払額に届いていない",
    "nothing_due": "支払うものがない",
    "carry_exceeds_outstanding": "お店への未払いの方が多い",
    "payout_in_progress": "すでに支払い中",
    "consignor_closed": "委託者が終了している",
    "no_payout_destination": "口座がまだない"
  },
  "settlements": {
    "intro": "売れた委託カードすべて。販売価格・お店の取り分・委託者の受取を表示します。数字はシステムが計算します。",
    "pay": "委託者に支払う",
    "only_of": "この方の販売だけ：",
    "everyone": "全員",
    "view_awaiting": "支払い待ち",
    "view_adjusted": "変更あり・要確認",
    "month": "売れた月",
    "all_months": "すべての月",
    "custom_range": "{{from}} 〜 {{to}}"
  },
  "deductions": {
    "title": "販売",
    "intro": "このカードで委託者が受け取る金額です。",
    "load_failed": "この販売を読み込めませんでした。",
    "caption": "委託者の受取の計算",
    "refunded": "お客様に返金",
    "needs_review": "販売後に変更がありました（返金・価格）。支払う前に数字を確認してください。",
    "add_title": "送料・鑑定料などを差し引く",
    "kind": "内容",
    "amount": "金額",
    "note": "委託者へのメモ",
    "add": "差し引く",
    "add_hint": "この行は委託者の精算書に載ります。",
    "remove": "{{label}}を削除",
    "remove_title": "この差し引きを削除しますか？",
    "locked": "支払済み（または確定）のため、差し引きは変更できません。",
    "recalculate": "今日の手数料でもう一度計算",
    "recalculated": "もう一度計算しました。",
    "consequence": "委託者の受取をシステムがもう一度計算します。",
    "confirm": "保存",
    "saved": "保存しました。委託者の受取を計算し直しました。",
    "payments": "支払い"
  },
  "wizard": {
    "title": "委託者に支払う",
    "intro": "誰に・どの販売を・どうやって。お金の支払いはシステムの外（銀行・現金）で行い、ここに記録します。",
    "load_failed": "支払い対象を計算できませんでした。",
    "steps": "手順",
    "step_who": "誰に",
    "step_sales": "どの販売",
    "step_how": "支払い方法",
    "who_title": "支払う人",
    "nobody": "今、支払う相手はいません。",
    "nobody_body": "売れた委託カードは、精算が終わるとここに出ます。",
    "sales_one": "{{count}}件",
    "sales_other": "{{count}}件",
    "skipped_one": "今回支払わない人が{{count}}人います",
    "skipped_other": "今回支払わない人が{{count}}人います",
    "include_below": "最低支払額に届かない人にも支払う",
    "sales_title": "どの販売を支払うか",
    "carry": "お店への未払いを差し引き",
    "pays": "支払額",
    "amount_on_save": "金額は保存するときに計算します",
    "how_title": "支払い方法",
    "method": "方法",
    "transfer_when": "銀行振込",
    "paid_later": "これから振り込む（振込ファイルを作り、あとで記録）",
    "paid_now": "もう振り込んだ",
    "paid_on": "支払日",
    "paid_on_hint": "お金を送った日（日本時間）。",
    "reference": "振込の受付番号",
    "reference_hint": "銀行の振込受付番号。",
    "slip": "振込明細（任意）",
    "cash_location": "支払うレジの店舗",
    "cash_location_hint": "この店舗の開いているレジから現金を出します。",
    "signature": "署名した受領書の写真",
    "store_credit_note": "ストアクレジットはお店で最長6か月使えます（資金決済法）。",
    "no_bank_file": "振込ファイルは、選んだ全員の全部の販売をまとめて支払うときに作られます。",
    "summary": "まとめ",
    "total": "合計",
    "next": "次へ",
    "back": "戻る",
    "create": "支払いを作る",
    "record_paid": "支払済みにする",
    "confirm_title": "支払いを作りますか？",
    "confirm_paid_title": "支払いを記録しますか？",
    "confirm_later_one": "{{count}}件の支払いが振込待ちになります。",
    "confirm_later_other": "{{count}}件の支払いが振込待ちになります。",
    "confirm_paid_one": "委託者に知らせ、精算書を送ります。",
    "confirm_paid_other": "{{count}}人の委託者に知らせ、精算書を送ります。",
    "done_one": "{{count}}件の支払いを作りました。",
    "done_other": "{{count}}件の支払いを作りました。",
    "some_failed": "支払えなかった人がいます：",
    "to_list": "支払い一覧へ"
  },
  "bank_file": {
    "download": "振込ファイルをダウンロード",
    "saved": "振込ファイルを保存しました。銀行のソフトかExcelで開けます。",
    "next_steps": "銀行にファイルを送って振り込み、そのあと各支払いを支払済みにしてください。"
  },
  "statement": {
    "open": "精算書",
    "making": "精算書を作成中…",
    "failed": "精算書がまだ作れていません。自動でやり直します。",
    "mailed": "委託者にはメールとポータルで精算書が届きます。"
  },
  "payouts": {
    "intro": "委託者へのすべての支払い。振込待ちの支払いは、振り込んだあとここで記録します。",
    "pay": "委託者に支払う",
    "reference": "番号",
    "amount": "金額",
    "method": "方法",
    "paid_on": "支払日",
    "statement": "精算書",
    "statement_ready": "あり",
    "view_processing": "振込待ち"
  },
  "detail": {
    "title": "支払い",
    "load_failed": "この支払いを読み込めませんでした。",
    "paid_on": "支払日",
    "run": "まとめ払い {{reference}}",
    "sales": "この支払いの販売",
    "this_payout": "今回の支払い",
    "record_title": "振込を記録",
    "record_intro": "振り込んだあとに、日付と振込の受付番号を入れます。",
    "record": "支払済みにする",
    "record_consequence": "委託者に知らせ、精算書を送ります。",
    "paid_done": "支払済みにしました。",
    "cancel": "この支払いをやめる",
    "cancel_title": "この支払いをやめますか？",
    "cancel_consequence": "まだ支払っていません。販売は次の支払いに回ります。",
    "cancelled": "支払いをやめました。"
  },
  "problems": {
    "reference": "振込の受付番号を入れてください。",
    "signature": "署名した受領書の写真を追加してください。"
  }
}
